export async function paymentServices() {
  const response = await fetch(
    "https://fitmeal-payment-api-1.onrender.com/api/orderDetails/FetchPaymentDetails"
  );
  if (response.ok) {
    const paymentDetails = response.json();
    return paymentDetails;
  } else {
    throw new Error("Unable to fetch payment Details");
  }
}
